export const searchAndScrollToText = (keyword: string, elementsClassName: string) => {
  const contentElements = document.getElementsByClassName(elementsClassName)
  for (let i = 0; i < contentElements.length; i++) {
    const element = contentElements[i]

    const index = element?.innerHTML?.toLowerCase()?.indexOf(keyword)
    if (element && index !== -1) {
      element?.scrollIntoView({ behavior: 'smooth' })
      break
    }
  }
}
